<template>
  <div class="question-vars">
    <div class="question-vars__top">
      <div class="question-vars__title">
        <span>{{ $tr('variables.vars-and-formulas') }}</span>

        <vbutton v-if="variables.length < 10" label="actions.add" size="small" @click="addVariable(questionId)" />
      </div>

      <div class="question-vars__precision">
        <label>{{ $tr('variables.rouding-precision') }}</label>
        <vinput
          :value="roundingPrecision"
          type="number"
          border
          @input="SET_QUESTION_PROPERTY({ questionId, property: 'rounding_precision', newValue: $event })"
        />
      </div>
    </div>

    <div v-for="(item, index) in variables" :key="index" class="question-vars__variable">
      <div class="question-vars__variable-title">
        <div>
          <div class="question-vars__variable-name">
            <div>{{ item.name }}</div>
          </div>
        </div>

        <div
          v-if="variables.length > 0"
          class="question-vars__variable-remove"
          @click="REMOVE_VARIABLE({ questionId, variableName: item.name })"
        >
          <i class="icon icon-recycle_bin"></i>
        </div>
      </div>

      <div class="question-vars__variable-input">
        <trigger
          :value="item.isFormula"
          small
          :text="$tr('variables.vars-and-formulas')"
          @input="
            UPDATE_VARIABLE({
              questionId,
              variableName: item.name,
              property: 'isFormula',
              newValue: $event
            })
          "
        />

        <trigger
          :value="isIntegerNumber(item.type)"
          :text="$tr('variables.integer-number')"
          small
          @input="UPDATE_VARIABLE({ questionId, variableName: item.name, property: 'type', newValue: $event })"
        />
      </div>

      <div v-if="item.isFormula" class="question-vars__variable-input">
        <label>{{ $tr('variables.exact-or-formula') }}</label>
        <vinput
          :value="item.formula"
          border
          @input="UPDATE_VARIABLE({ questionId, variableName: item.name, property: 'formula', newValue: $event })"
        />
      </div>

      <div v-else class="question-vars__variable-group">
        <div class="question-vars__variable-group-item">
          <label>Min</label>
          <vinput
            :value="item.min"
            border
            @input="UPDATE_VARIABLE({ questionId, variableName: item.name, property: 'min', newValue: $event })"
          />
        </div>

        <div class="question-vars__variable-group-item">
          <label>Max</label>
          <vinput
            :value="item.max"
            border
            @input="UPDATE_VARIABLE({ questionId, variableName: item.name, property: 'max', newValue: $event })"
          />
        </div>

        <div class="question-vars__variable-group-item">
          <label>{{ $tr('variables.step') }}</label>
          <vinput
            :value="item.step"
            border
            @input="UPDATE_VARIABLE({ questionId, variableName: item.name, property: 'step', newValue: $event })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Trigger from '@/components/shared/Trigger';
import { mapMutations } from 'vuex';

export default {
  name: '',

  components: {
    Trigger
  },

  props: {
    questionId: {
      type: [String, Number],
      default: ''
    },

    roundingPrecision: {
      type: [String, Number],
      default: 0
    },

    variables: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    ...mapMutations('vacancyTests', ['SET_QUESTION_PROPERTY', 'ADD_VARIABLE', 'REMOVE_VARIABLE', 'UPDATE_VARIABLE']),

    addVariable(questionId) {
      let newName = '';
      const variableTemplates = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];

      variableTemplates.every(element => {
        const findVariable = this.variables.find(x => x.name === element);

        if (findVariable === undefined) {
          newName = element;

          return false; // stops every
        }

        return true;
      });

      const newVariable = {
        name: newName,
        formula: '',
        isFormula: false, // добавлено свойство на фронте. false потому что поле formula пустое
        min: 1,
        max: 10,
        step: 0,
        type: 1
      };

      this.ADD_VARIABLE({ questionId, newVariable });
    },

    isIntegerNumber(value) {
      // 1 - integer number, 2 - float number
      if (value === 1) {
        return true;
      } else if (value === 2) {
        return false;
      }

      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.question-vars {
  padding: 10px 0 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 10px;

  &__top {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
    flex-direction: column;
  }

  &__precision {
    padding: 10px 0;
    display: flex;
    max-width: 250px;
    flex-direction: column;

    label {
      @include mixin-text-tag;
      margin-bottom: 5px;
    }
  }

  // variables
  &__title {
    @include mixin-text-header;
    display: flex;
    width: 100%;
    justify-content: space-between;
    border-bottom: 1px solid $grey-light;
    align-items: center;
    padding-bottom: 10px;
  }

  // variable
  &__variable {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    padding: 10px 20px;
    width: 50%;
    position: relative;
  }

  &__variable-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 7px;
  }

  &__variable-name {
    @include mixin-text-header-big;

    > div {
      border: 1px solid $main-dark;
      text-align: center;
      padding: 0 10px;
      height: 30px;
      display: flex;
      display: inline-block;
      border-radius: 4px;
      cursor: default;
    }
  }

  &__variable-title-input {
    height: 30px !important;
    border-radius: 3px;
  }

  &__variable-remove {
    margin-left: 5px;
    height: 30px;
    width: 30px;
    font-size: 22px;
    color: $grey;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      color: $red;
    }
  }

  &__variable-input {
    width: 100%;
    margin-bottom: 10px;

    label {
      @include mixin-text-tag;
    }
  }

  &__variable-group {
    display: flex;
    margin-bottom: 7px;
  }

  &__variable-group-item {
    width: 30%;

    &:first-child {
      margin-right: 5%;
    }

    &:last-child {
      margin-left: 5%;
    }

    label {
      @include mixin-text-tag;
    }
  }
}
</style>
